// In-place editing for the "This Customer's Price" column on a wholesale
// account's page: each price is its own small form (see
// admin/wholesale_juice_prices/_table.html.erb). Leaving the field (blur) or
// pressing Enter saves just that one price via fetch, with no page reload -
// with JS off, the same form still works as a normal submit.

function csrfToken() {
  var meta = document.querySelector('meta[name="csrf-token"]')
  return meta ? meta.content : ''
}

function setStatus(input, text, kind) {
  var status = input.closest('.js-wholesale-price-form').querySelector('.wholesale-price-status')
  if (!status) return

  status.textContent = text
  status.classList.remove('is-saved', 'is-error')
  if (kind) status.classList.add(kind)
}

function savePrice(input) {
  var form = input.closest('.js-wholesale-price-form')
  if (!form) return

  input.disabled = true
  setStatus(input, 'Saving…', null)

  fetch(form.action, {
    method: 'PATCH',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-CSRF-Token': csrfToken(),
      Accept: 'application/json'
    },
    body: encodeURIComponent(input.name) + '=' + encodeURIComponent(input.value)
  })
    .then(function (response) {
      if (!response.ok) return response.json().then(function (data) { throw new Error(data.error || 'Could not save that price.') })

      input.defaultValue = input.value
      setStatus(input, 'Saved', 'is-saved')
    })
    .catch(function (error) {
      setStatus(input, error.message, 'is-error')
    })
    .then(function () {
      input.disabled = false
    })
}

document.addEventListener(
  'blur',
  function (event) {
    var input = event.target.closest && event.target.closest('.js-wholesale-price-form .js-wholesale-price-input')
    if (!input || input.value === input.defaultValue) return

    savePrice(input)
  },
  true // blur doesn't bubble, so this has to run during the capture phase
)

document.addEventListener('keydown', function (event) {
  var input = event.target.closest && event.target.closest('.js-wholesale-price-form .js-wholesale-price-input')
  if (!input || event.key !== 'Enter') return

  // Stop the browser's own implicit submit (a full page reload); the blur
  // handler above does the actual save once the field loses focus.
  event.preventDefault()
  input.blur()
})
